import { useState, useEffect } from 'react'
import { Card, Button, Input, Badge } from '../../components/ui'
import { Search, Loader2, MoreVertical, Trophy, Calendar, MapPin, ExternalLink } from 'lucide-react'
import { supabase } from '../../lib/supabase'
import { Link } from 'react-router-dom'

export const PlatformTournaments = () => {
    const [tournaments, setTournaments] = useState([])
    const [loading, setLoading] = useState(true)
    const [search, setSearch] = useState('')

    useEffect(() => {
        fetchTournaments()
    }, [])

    const fetchTournaments = async () => {
        try {
            // Fetch tournaments with tenant info if possible, otherwise just tournaments
            // Assuming we can just verify existence for now
            const { data, error } = await supabase
                .from('tournaments')
                .select('*')
                .order('created_at', { ascending: false })

            if (error) throw error
            setTournaments(data)
        } catch (error) {
            console.error('Error fetching tournaments:', error)
        } finally {
            setLoading(false)
        }
    }

    const filteredTournaments = tournaments.filter(t =>
        t.name?.toLowerCase().includes(search.toLowerCase()) ||
        t.id?.toLowerCase().includes(search.toLowerCase())
    )

    return (
        <div className="p-8 max-w-7xl mx-auto bg-gray-50 min-h-screen">
            <div className="flex justify-between items-center mb-8">
                <div>
                    <h1 className="text-3xl font-bold text-gray-900 mb-2 flex items-center gap-3">
                        <Trophy className="text-orange-500" size={32} />
                        Alle Toernooien
                    </h1>
                    <p className="text-gray-500">Centraal overzicht van alle competities op het platform.</p>
                </div>
                <div className="flex gap-3">
                    <Button variant="outline">Exporteer CSV</Button>
                </div>
            </div>

            <Card className="p-4 mb-6">
                <div className="relative">
                    <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={20} />
                    <Input
                        placeholder="Zoek toernooi..."
                        className="pl-10"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                </div>
            </Card>

            {loading ? (
                <div className="flex justify-center py-12">
                    <Loader2 className="animate-spin text-orange-500" size={40} />
                </div>
            ) : (
                <div className="grid gap-4">
                    {filteredTournaments.length === 0 ? (
                        <div className="text-center py-12 text-gray-500">Geen toernooien gevonden.</div>
                    ) : (
                        filteredTournaments.map(tournament => (
                            <div key={tournament.id} className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 flex items-center justify-between hover:shadow-md transition-shadow">
                                <div className="flex items-center gap-6">
                                    <div className="w-12 h-12 bg-orange-100 rounded-xl flex items-center justify-center text-orange-600">
                                        <Trophy size={24} />
                                    </div>
                                    <div>
                                        <h3 className="font-bold text-lg text-gray-900 flex items-center gap-2">
                                            {tournament.name}
                                            <Badge variant={tournament.status === 'active' ? 'success' : 'default'} size="sm">
                                                {tournament.status || 'Draft'}
                                            </Badge>
                                        </h3>
                                        <div className="flex items-center gap-4 text-sm text-gray-500 mt-1">
                                            <span className="flex items-center gap-1"><Calendar size={14} /> {new Date(tournament.created_at).toLocaleDateString()}</span>
                                            {tournament.location && <span className="flex items-center gap-1"><MapPin size={14} /> {tournament.location}</span>}
                                        </div>
                                    </div>
                                </div>

                                <div className="flex items-center gap-4">
                                    <Link to={`/live/${tournament.id}`} target="_blank">
                                        <Button variant="ghost" size="sm" className="gap-2">
                                            <ExternalLink size={16} /> Live Bekijken
                                        </Button>
                                    </Link>
                                </div>
                            </div>
                        ))
                    )}
                </div>
            )}
        </div>
    )
}
